(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.OverflowMenu = factory());
}(this, (function () { 'use strict';

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  var ResizeMonitor = /*#__PURE__*/function () {
    function ResizeMonitor(windowElement, documentFonts) {
      _classCallCheck(this, ResizeMonitor);

      var _a, _b;

      this.headObservers = [];
      this.recalculateCallbacks = [];
      this.resizeCallbacks = [];
      this.started = false;
      this.window = windowElement || window;
      this.documentFonts = documentFonts || ((_b = (_a = this.window) === null || _a === void 0 ? void 0 : _a.document) === null || _b === void 0 ? void 0 : _b.fonts);
      this.bindings = {
        processRecalculate: this.processRecalculate.bind(this),
        processResize: this.processResize.bind(this),
        onDomChanges: this.onDomChanges.bind(this)
      };
    }

    _createClass(ResizeMonitor, [{
      key: "start",
      value: function start() {
        if (this.started) {

          return;
        }

        this.started = true;
        var readyState = this.window.document.readyState;

        if (readyState === 'complete') {
          // If we are already loaded we can go ahead and refresh.
          this.processRecalculate();
        } else {
          // Otherwise recalculate when the dom is ready and when everything is loaded.
          if (readyState !== 'interactive') {
            this.window.addEventListener('DOMContentLoaded', this.bindings.processRecalculate);
          }

          this.window.addEventListener('load', this.bindings.processRecalculate);
        }

        this.window.addEventListener('resize', this.bindings.processResize); // Monitor the head element for changes to detect any stylesheets that are added after load.

        var headNode = this.window.document.querySelector('head');

        if (headNode !== null) {
          this.monitorDom(headNode);
        } // Listen for fonts to be ready in case the size changes when they do.


        this.monitorFonts();
      }
    }, {
      key: "stop",
      value: function stop() {
        this.started = false;
        this.window.removeEventListener('resize', this.bindings.processResize);
        this.window.removeEventListener('DOMContentLoaded', this.bindings.processRecalculate);
        this.window.removeEventListener('load', this.bindings.processRecalculate);
        this.headObservers.forEach(function (observer) {
          return observer.disconnect();
        });
      }
    }, {
      key: "onRecalculateSizes",
      value: function onRecalculateSizes(callback) {
        this.recalculateCallbacks.push(callback);
      }
    }, {
      key: "processRecalculate",
      value: function processRecalculate() {
        this.recalculateCallbacks.forEach(function (callback) {
          return callback();
        });
      }
    }, {
      key: "onResize",
      value: function onResize(callback) {
        this.resizeCallbacks.push(callback);
      }
    }, {
      key: "processResize",
      value: function processResize() {
        this.resizeCallbacks.forEach(function (callback) {
          return callback();
        });
      } // noinspection JSMethodCanBeStatic

    }, {
      key: "onDomChanges",
      value: function onDomChanges(mutations) {
        var _this = this;

        mutations.forEach(function (mutation) {
          if (mutation.type !== 'childList') {
            return;
          }

          mutation.addedNodes.forEach(function (node) {
            if (!['link', 'style'].includes(node.nodeName.toLowerCase())) {
              return;
            } // If a link or style tag are added we wait for them to load to refresh.  We also need to
            // re-listen for font loading in case the stylesheet loaded new items


            node.addEventListener('load', function () {
              _this.processRecalculate();

              _this.monitorFonts();
            });
          });
        });
      }
    }, {
      key: "monitorDom",
      value: function monitorDom(element) {
        var observer = new MutationObserver(this.bindings.onDomChanges);
        observer.observe(element, {
          childList: true,
          subtree: true
        });
        this.headObservers.push(observer);
      }
    }, {
      key: "monitorFonts",
      value: function monitorFonts() {
        if (this.documentFonts && this.documentFonts.status !== 'loaded') {
          this.documentFonts.ready.then(this.bindings.processRecalculate);
        }
      }
    }]);

    return ResizeMonitor;
  }();

  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/isNaN#Polyfill
  Number.isNaN = Number.isNaN || function isNaN(input) {
    // The following works because NaN is the only value in javascript which is not equal to itself.
    // eslint-disable-next-line no-self-compare
    return typeof input === 'number' && input !== input;
  };

  function getStyleSum(element, properties) {
    var computedStyle = window.getComputedStyle(element);
    var sum = 0;
    properties.forEach(function (property) {
      var computedValue = computedStyle.getPropertyValue(property);

      if (!computedValue) {
        return;
      }

      var parsed = parseFloat(computedValue);

      if (Number.isNaN(parsed)) {

        return;
      }

      sum += parsed;
    });
    return sum;
  }

  function getWidth(element) {
    return element.getBoundingClientRect().width;
  }
  function getInsideWidth(element) {
    return Math.max(0, getWidth(element) - getStyleSum(element, ['padding-left', 'padding-right']));
  }
  function getOutsideWidth(element) {
    return getWidth(element) + getStyleSum(element, ['margin-left', 'margin-right']);
  }

  var OverflowMenu = /*#__PURE__*/function () {
    function OverflowMenu(options) {
      var _this = this;

      _classCallCheck(this, OverflowMenu);

      // noinspection JSUnusedGlobalSymbols -- They are not unused, they are merged in constructor
      this.defaultOptions = {
        overflowActiveClass: 'overflow-active',
        calculateContainerWidth: function calculateContainerWidth(element) {
          return Math.floor(getInsideWidth(element));
        },
        calculateItemWidth: function calculateItemWidth(element) {
          return Math.ceil(getOutsideWidth(element));
        },
        showOverflowItem: function showOverflowItem(element) {
          if (_this.options.overflowActiveClass) {
            element.classList.add(_this.options.overflowActiveClass);
          }
        },
        hideOverflowItem: function hideOverflowItem(element) {
          if (_this.options.overflowActiveClass) {
            element.classList.remove(_this.options.overflowActiveClass);
          }
        },
        findItems: function findItems(selector) {
          return Array.prototype.slice.call(_this.options.itemContainer.querySelectorAll(selector));
        }
      };
      this.breakpoints = [];
      this.overflowItemWidth = 0;
      this.isOverflowing = false;
      this.options = Object.assign(Object.assign({}, this.defaultOptions), options);
      this.isHidden = this.options.itemContainer.offsetWidth === 0;
    }

    _createClass(OverflowMenu, [{
      key: "refreshMenu",
      value: function refreshMenu() {
        var _this2 = this;

        var _this$options = this.options,
            calculateContainerWidth = _this$options.calculateContainerWidth,
            showOverflowItem = _this$options.showOverflowItem,
            hideOverflowItem = _this$options.hideOverflowItem;

        if (!calculateContainerWidth || !showOverflowItem || !hideOverflowItem) {
          return;
        }

        var containerWidth = calculateContainerWidth(this.options.itemContainer); // If the element visibility changes we need to recalculate the widths.  If we don't and the
        // menu started hidden all of the widths will be set to 0.

        var itemContainerIsHidden = containerWidth === 0;

        if (itemContainerIsHidden !== this.isHidden) {
          this.isHidden = itemContainerIsHidden; // We only need to recalculate if we're being shown.

          if (!itemContainerIsHidden) {
            this.refreshSizes();
          }
        } // If we are hidden there is no point continuing.


        if (this.isHidden) {
          return;
        }

        var reversedBreakpoints = this.breakpoints.slice().reverse(); // We check this outside of the loop so we only subtract the overflow item width only when
        // needed. If we always subtract it we can end up switching to the overflow when an item would
        // still fit.  We check against the reversed array so we are comparing the highest maxWidth
        // first.

        this.isOverflowing = reversedBreakpoints.find(function (_ref) {
          var maxWidth = _ref.maxWidth;
          return maxWidth > containerWidth;
        }) !== undefined; // If we are overflowing we need to subtract the overflow item width from the container to
        // account for it being visible.

        if (this.isOverflowing) {
          containerWidth -= this.overflowItemWidth;
        } // When adding we loop through the breakpoints in reverse order so we can only insert what is
        // needed and maintain the correct item order.


        reversedBreakpoints.forEach(function (_ref2) {
          var element = _ref2.element,
              maxWidth = _ref2.maxWidth;

          if (maxWidth > containerWidth && element.parentElement !== _this2.options.overflowContainer) {
            _this2.options.overflowContainer.insertBefore(element, _this2.options.overflowContainer.firstChild);
          }
        }); // When removing we don't need to reverse since they will always be removed in order.

        this.breakpoints.forEach(function (_ref3) {
          var element = _ref3.element,
              maxWidth = _ref3.maxWidth;

          if (maxWidth <= containerWidth && element.parentElement === _this2.options.overflowContainer) {
            _this2.options.itemContainer.insertBefore(element, _this2.options.overflowItem);
          }
        });

        if (this.isOverflowing) {
          showOverflowItem(this.options.overflowItem);
        } else {
          hideOverflowItem(this.options.overflowItem);
        }
      }
    }, {
      key: "refreshSizes",
      value: function refreshSizes() {
        var _this3 = this;

        var _this$options2 = this.options,
            calculateItemWidth = _this$options2.calculateItemWidth,
            findItems = _this$options2.findItems,
            showOverflowItem = _this$options2.showOverflowItem,
            hideOverflowItem = _this$options2.hideOverflowItem;

        if (!calculateItemWidth || !findItems || !showOverflowItem || !hideOverflowItem) {
          return;
        } // Move any known items back into the root element so the size is calculated properly.


        this.breakpoints.map(function (info) {
          return _this3.options.itemContainer.insertBefore(info.element, _this3.options.overflowItem);
        });
        this.breakpoints = this.calculateBreakpoints(findItems(this.options.itemSelector).filter(function (item) {
          return item !== _this3.options.overflowItem;
        })); // Make sure the overflow menu is visible so we can calculate it's size properly.

        if (!this.isOverflowing) {
          showOverflowItem(this.options.overflowItem);
        }

        this.overflowItemWidth = calculateItemWidth(this.options.overflowItem);

        if (!this.isOverflowing) {
          hideOverflowItem(this.options.overflowItem);
        }
      }
    }, {
      key: "calculateBreakpoints",
      value: function calculateBreakpoints(menuItems) {
        var calculateItemWidth = this.options.calculateItemWidth;

        if (!calculateItemWidth) {
          return [];
        }

        var breakpoints = [];
        var currentMaxWidth = 0;
        menuItems.forEach(function (element) {
          var elementWidth = calculateItemWidth(element);
          currentMaxWidth += elementWidth;
          breakpoints.push({
            element: element,
            maxWidth: currentMaxWidth
          });
        });
        return breakpoints;
      }
    }]);

    return OverflowMenu;
  }();

  var itemContainerSelector = '[data-overflow-menu-items]';
  var overflowItemSelector = '[data-overflow-menu-more-item]';
  var overflowContainerSelector = '[data-overflow-menu-more-container]';
  var menus = [];
  var monitor = new ResizeMonitor(window);
  monitor.onRecalculateSizes(function () {
    menus.forEach(function (info) {
      info.menu.refreshSizes();
      info.menu.refreshMenu();
    });
  });
  monitor.onResize(function () {
    menus.forEach(function (info) {
      return info.menu.refreshMenu();
    });
  });

  var createMenus = function createMenus() {
    window.document.querySelectorAll(itemContainerSelector).forEach(function (element) {
      var htmlElement = element;
      var menuItemSelector = htmlElement.dataset.overflowMenuItems || '';

      if (!menuItemSelector) {

        return;
      }

      var overflowItem = htmlElement.querySelector(overflowItemSelector);
      var overflowContainer = htmlElement.querySelector(overflowContainerSelector);

      if (!overflowItem || !overflowContainer) {

        return;
      }

      var menu = new OverflowMenu({
        itemContainer: htmlElement,
        itemSelector: menuItemSelector,
        overflowItem: overflowItem,
        overflowContainer: overflowContainer
      });
      menus.push({
        menu: menu,
        element: htmlElement
      });
    });

    if (menus.length) {
      monitor.start();
    }
  };

  var readyState = window.document.readyState;

  if (readyState === 'complete' || readyState === 'interactive') {
    createMenus();
  } else {
    window.document.addEventListener('DOMContentLoaded', function () {
      return createMenus();
    });
  }

  var index = {
    OverflowMenu: OverflowMenu,
    ResizeMonitor: ResizeMonitor,
    GetResizeMonitor: function GetResizeMonitor() {
      return monitor;
    },
    FindMenu: function FindMenu(element) {
      var _a;

      return (_a = menus.find(function (i) {
        return i.element === element;
      })) === null || _a === void 0 ? void 0 : _a.menu;
    }
  };

  return index;

})));
